import { PERSON_CONTEXT_DESC_REF } from "../actions";

export default function(state = {}, action) {

  switch (action.type) {
    case PERSON_CONTEXT_DESC_REF:
      //console.log('rdcr_persons_context_desc_ref -- PERSON_CONTEXT_DESC_REF -- action.payload', action.payload)
      return action.payload;
    default:
      return state;
  }
}